(function () {
  function readMs(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function isTopAtViewportCenter(rect, viewH) {
    var viewCenter = viewH / 2;
    return rect.top <= viewCenter && rect.bottom > viewCenter;
  }

  function initRound1(root) {
    if (!root || root.dataset.round1Ready === 'true') return;
    root.dataset.round1Ready = 'true';

    var cover = root.querySelector('[data-round1-cover]');
    if (!cover) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      cover.classList.add('is-gone');
      return;
    }

    var fadeDuration = readMs(root.getAttribute('data-fade-duration'), 1000);
    cover.style.transitionDuration = fadeDuration + 'ms';
    cover.classList.add('is-playing');

    var coverHidden = false;
    var fadingOut = false;
    var lastScrollY = window.scrollY || window.pageYOffset || 0;
    var lastTouchY = null;
    var fadeTimer = null;

    function clearFadeTimer() {
      if (fadeTimer) {
        window.clearTimeout(fadeTimer);
        fadeTimer = null;
      }
    }

    function finishFadeOut() {
      cover.classList.add('is-gone');
      cover.classList.remove('is-fading');
      coverHidden = true;
      fadingOut = false;
    }

    function beginFadeOut() {
      if (coverHidden || fadingOut) return;
      fadingOut = true;
      clearFadeTimer();
      cover.classList.add('is-fading');
      fadeTimer = window.setTimeout(finishFadeOut, fadeDuration);
    }

    function onScrollDown() {
      if (coverHidden || fadingOut) return;
      var rect = root.getBoundingClientRect();
      var viewH = window.innerHeight || 1;
      if (isTopAtViewportCenter(rect, viewH)) beginFadeOut();
    }

    function handleDirection(delta) {
      if (delta > 0) onScrollDown();
    }

    function onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      handleDirection(y - lastScrollY);
      lastScrollY = y;
    }

    function onWheel(event) {
      handleDirection(event.deltaY);
    }

    function onTouchStart(event) {
      if (!event.touches || !event.touches.length) return;
      lastTouchY = event.touches[0].clientY;
    }

    function onTouchMove(event) {
      if (lastTouchY == null || !event.touches || !event.touches.length) return;
      var y = event.touches[0].clientY;
      handleDirection(lastTouchY - y);
      lastTouchY = y;
    }

    window.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('wheel', onWheel, { capture: true, passive: true });
    window.addEventListener('touchstart', onTouchStart, { capture: true, passive: true });
    window.addEventListener('touchmove', onTouchMove, { capture: true, passive: true });

    root._round1Cleanup = function () {
      window.removeEventListener('scroll', onScroll, { capture: true });
      window.removeEventListener('wheel', onWheel, { capture: true });
      window.removeEventListener('touchstart', onTouchStart, { capture: true });
      window.removeEventListener('touchmove', onTouchMove, { capture: true });
      clearFadeTimer();
    };
  }

  function initAll() {
    document.querySelectorAll('[data-jojo-campaign-round1]').forEach(initRound1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-jojo-campaign-round1]')
      : null;
    if (!root) return;
    if (typeof root._round1Cleanup === 'function') root._round1Cleanup();
    root.dataset.round1Ready = 'false';
    initRound1(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-jojo-campaign-round1]')
      : null;
    if (!root || typeof root._round1Cleanup !== 'function') return;
    root._round1Cleanup();
  });
})();
